export function roundMoney(amount) {
  return Math.round((amount + Number.EPSILON) * 100) / 100;
}

function fee(amount, type, value) {
  return type === 'FlatAmount' ? Number(value || 0) : amount * Number(value || 0) / 100;
}

export function calculateFeeBreakdown(rentalAmount, rule, venueAbsorbsFees = false) {
  const tiers = rule.bookingFeeTiers || [];
  const matchingTier = tiers.slice()
    .sort((a, b) => Number(a.minimumAmount) - Number(b.minimumAmount))
    .find((tier) => rentalAmount >= Number(tier.minimumAmount) &&
      (tier.maximumAmount == null || tier.maximumAmount === '' || rentalAmount <= Number(tier.maximumAmount)));
  const bookingFee = roundMoney(matchingTier
    ? fee(rentalAmount, matchingTier.rateType, matchingTier.rateValue) +
      (matchingTier.rateType === 'Percentage' ? Number(matchingTier.fixedFeeAmount || 0) : 0)
    : tiers.length ? 0 : fee(rentalAmount, rule.bookingFeeRateType, rule.bookingFeeRateValue));
  const customerConvenienceFee = venueAbsorbsFees ? 0 : bookingFee;
  const customerTotal = roundMoney(rentalAmount + customerConvenienceFee);
  const providerFee = roundMoney(fee(customerTotal, rule.rateType, rule.rateValue) + Number(rule.providerFixedFeeAmount || 0));
  const providerFeeVat = roundMoney(providerFee * Number(rule.providerFeeVatRate ?? 12) / 100);
  const providerCost = roundMoney(providerFee + providerFeeVat);
  return { matchingTier, bookingFee, customerConvenienceFee, customerTotal, providerFee, providerFeeVat,
    providerCost, grossProfit: roundMoney(bookingFee - providerCost) };
}
